// login
export const START_LOGIN = "START_LOGIN";

// account
export const SET_ACCOUNT_ID = "SET_ACCOUNT_ID";
export const CHANGE_ACCOUNT_ID = "CHANGE_ACCOUNT_ID";
